interface IErrorData {
  type: string;
  message: string;
}

export enum DEEPLINKS {
  eraserType = 'eraserType',
}

export enum KeyCodes {
  enter = 'Enter',
  esc = 'Escape',
  keyZ = 'KeyZ',
  minus = 'Minus',
  equal = 'Equal',
  numpadAdd = 'NumpadAdd',
  numpadSubtract = 'NumpadSubtract',
  space = 'Space',
  numpadEnter = 'NumpadEnter',
}

export enum ToolTypes {
  removeObjectBg = 'tool_removeBG',
}

export enum BatchDataStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  DONE = 'done',
  ERROR = 'error',
}

export enum EnhanceProgressStatuses {
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}

export const SDK_API_URL = 'https://api.picsart.io';
export const API_PLATFORM = 'website';

export const BROWSER_MAXIMUM_PARALLEL_CONNECTIONS = 6;
export const maxToken = 77;

export const CDN_130 = import.meta.env.VITE_APP_CDN_130 || 'https://cdn130.picsart.com';
export const CDN_140 = import.meta.env.VITE_APP_CDN_140;

export const apiUploadUrl = import.meta.env.VITE_APP_UPLOAD_URL;
export const PA_STATIC = import.meta.env.VITE_APP_PA_STATIC;

export const zoomValues = {
  z_100: {
    label: '100%',
    value: 1,
  },
  z_200: {
    label: '200%',
    value: 2,
  },
  z_300: {
    label: '300%',
    value: 3,
  },
  z_75: {
    label: '75%',
    value: 0.75,
  },
  z_50: {
    label: '50%',
    value: 0.5,
  },
  z_25: {
    label: '25%',
    value: 0.25,
  },
  z_10: {
    label: '10%',
    value: 0.1,
  },
  fit: {
    label: 'Fit',
    value: 1,
  },
  fill: {
    label: 'Fill',
    value: 'fill',
  },
};

export const ZOOM_INPUT_CHANGE_VALUE = 0.01;
export const ZOOM_INPUT_DOUBLE_STEP_VALUE = 0.02;
export const PHOTO = 'photo';
export const BACKGROUND = 'background';
export const VIDEO = 'video';
export const SHAPE = 'shape';
export const STICKER = 'sticker';
export const scrollBarsLayerId = 'scroll-layers';
export const TEXT = 'text';
export const PREMIUM = 'premium';

export const WATERMARK_PATTERN_SIZE = 165;
export const WATERMARK = 'wordMark';
export const TEXT_STYLE = 'text_style';

// Market for API
export const API_MARKET = 'website';
export const SOURCE_EDITOR_FIT = 'batch_editor';

export const PREMIUM_FEATURES = {
  default: {
    title: 'Premium feature',
    contentBeforeLink: 'Upgrade to Picsart Gold to remove the watermark and enjoy other premium perks.',
  },
  trialUnUsed: {
    title: 'Go watermark-free?',
    contentBeforeLink: 'Enjoy a free 7-day trial of Picsart Gold, and try out every premium tool and feature.',
  },
  proTrialUsed: {
    title: 'You’ve discovered a premium item',
    contentBeforeLink: 'Enjoy millions more stock photos, unlimited access to all AI tools, and lots more by upgrading to Picsart Pro.',
  },
  proWithTrial: {
    title: 'You’ve discovered a premium item',
    contentBeforeLink: 'Enjoy a free 7-day trial of Picsart Pro for access to premium stock photos, all AI tools, and lots more!',
  },
};

// search page analytic
export const FREE_TO_EDIT = 'fte';

export const apiBaseUrl = import.meta.env.VITE_APP_API_URL;

export const PICSART_URL = import.meta.env.VITE_APP_PICSART_URL;
export const appEnvironment = import.meta.env.VITE_APP_NODE_ENV;
export const isDev = appEnvironment === 'development';

export const LOCAL_STORAGE_PREFIX = 'we';

// Cookie names
export const SURVEY_AFTER_BATCH_EDITOR_DOWNLOAD = `${LOCAL_STORAGE_PREFIX}_survey_after_batch_editor_download`;

// info popup
export const EDITOR_INFO_POPUP = `${LOCAL_STORAGE_PREFIX}-info-popup`;

// Current user url
export const CURRENT_USER_URL = `${apiBaseUrl}/users/show/me.json`;

export const CURRENT_USER_LOCATION_URL = `${apiBaseUrl}/location`;

export const SCROLLBAR_FREE_SPACE_WIDTH = 2;
export const SCROLLBAR_SIZE = 6;
export const TOOL_ID = 'batch';

// app first opens
export const BATCH_EDITOR_FIRST_OPEN = `${LOCAL_STORAGE_PREFIX}-batch-editor-first-open`;

// Get user credits
export const AI_CREDIT_FEATURES_URL = `${apiBaseUrl}/shop/subscription/features`;

// Pluggable webhook (used by webhook presets)
export const SUBMIT_WEB_HOOK_URL = `${apiBaseUrl}/workflows/magic-flow-webhook/submit`;
export const MAGIC_FLOW_WEBHOOK_URL = `${apiBaseUrl}/workflows/magic-flow-webhook`;
export const WEBHOOK_CALCULATOR_URL = `${apiBaseUrl}/workflows/magic-flow-webhook-calculator/execute`;
export const WEBHOOK_FOLDER_NAME = 'Batch Editor';

// urls
export const WATERMARK_PATTERN_URL = `${PA_STATIC}/91671767329821691916.svg`;

// Error messages
export enum errorEnum {
  errorMessage = 'errorMessage',
}

// Messages
export enum Messages {
  PREMIUM_LAYER = 'Layer contains premium feature',
}

export enum ERROR_MESSAGES_KEYS {
  SERVER_ERROR = 'SERVER_ERROR',
}

export const ERROR_MESSAGES: Record<ERROR_MESSAGES_KEYS, IErrorData> = {
  [ERROR_MESSAGES_KEYS.SERVER_ERROR]: {
    type: errorEnum.errorMessage,
    message: 'Server error. Please try again in a couple of minutes.',
  },
};

// Modal messages
export const MODAL_MESSAGES = {
  imageWasDownloaded: 'Your image is successfully downloaded.',
  zipWasDownloaded: 'A zip file with your final images has successfully downloaded.',
  imageWasDownloadedDeviceTitle: 'Great edit!',
  imageWasDownloadedDriveTitle: `Saved to Picsart Drive`,
  imagesWereDownloadedDriveTitle: 'Saved {{count}} images to Picsart Drive',
  imageWasDownloadedDeviceContent: (format: 'JPG' | 'PNG') => `Saved ${format} to your device`,
  imagesWereDownloadedDeviceContent: (format: 'JPG' | 'PNG') => `Saved {{count}} ${format}s to your device`,
  imageWasDownloadedDriveContent: 'Access your images at any time and add them to future projects.',
};

// unsplash max image size
export const UNSPLASH_MAX_SIZE = 300;

export const aiServiceConfig = {
  personCutout: {
    size: 1024,
  },
  removeObjectBackground: {
    size: 768,
    max_width: 4000,
    max_height: 5000,
  },
  multiMatting: {
    size: 1024,
    max_width: 2048,
    max_height: 1024,
  },
  sky: {
    size: 288,
    max_width: 288,
    max_height: 288,
  },
};

export const { devicePixelRatio } = window;

export const zoomData = [
  {
    id: 1,
    label: zoomValues.z_300.label,
    value: zoomValues.z_300.value,
  },
  {
    id: 2,
    label: zoomValues.z_200.label,
    value: zoomValues.z_200.value,
  },
  {
    id: 3,
    label: zoomValues.z_100.label,
    value: zoomValues.z_100.value,
  },
  {
    id: 4,
    label: zoomValues.z_75.label,
    value: zoomValues.z_75.value,
  },
  {
    id: 5,
    label: zoomValues.z_50.label,
    value: zoomValues.z_50.value,
  },
  {
    id: 6,
    label: zoomValues.z_25.label,
    value: zoomValues.z_25.value,
  },
  {
    id: 7,
    label: zoomValues.z_10.label,
    value: zoomValues.z_10.value,
  },
  {
    id: 8,
    label: zoomValues.fit.label,
    value: zoomValues.fit.value,
  },
  {
    id: 9,
    label: zoomValues.fill.label,
    value: zoomValues.fill.value,
  },
];

export const notificationConfig = {
  verticalOffset: 23,
  horizontalOffset: 110,
  width: 479,
} as const;

export enum SuccessModalSourceEnum {
  editorDownload = 'editorDownload',
}

export const SURVEY_MONKEY_URLS = {
  batchEditorFirstSurvey: 'https://www.surveymonkey.co.uk/r/6H92YZC',
  batchEditorSecondSurvey: 'https://www.surveymonkey.co.uk/r/M69XKNP',
};

export const DOWNLOAD_SURVEY_OPENED_LOCATIONS = ['US'];

export const GET_TRANSPARENT_BG_URL = (isDarkMode: boolean) => (isDarkMode ? `${CDN_140}/75859750306610661420.png` : `${CDN_140}/93905496026471521548.png`);

export const needToRunApp = window.location.protocol === 'http:' || window.location.protocol === 'https:' || window.location.protocol === 'picsart-local://picsart-miniapp-local';

// PA Headers
export const PA_HEADERS = {
  platform: API_PLATFORM,
  market: API_MARKET,
};

export enum RemoveBgTabs {
  texture,
  color,
  resize,
}

export enum CropTabs {
  crop,
  rotate,
}

export enum PUBLISH_EVENT {
  OFFER = 'OpenOfferScreen',
  COLLECTION = 'SaveToCollection',
  REGISTRATION = 'OpenRegistrationScreen',
  PREMIUM_CONTENT_INFO = 'PremiumContentInfo',
}

export const INSUFFICIENT_CREDITS_REASON = 'not-enough-available-feature-uses';

export const TRIGGER_PREVIEW_TARGET = 'trigger-preview-target';

export enum PREVIEW_BG_COUNT {
  WITHOUT_BG = 4,
  WITH_BG = 3,
  ADDITIONAL = 2,
}

export enum REMOTE_THEMES {
  Dark = 'dark',
  Light = 'light',
  System = 'system',
}

export const LOCAL_STORAGE_KEYS = {
  theme: '-theme',
};

export enum ENVIRONMENT {
  Development = 'development',
  Stage = 'stage',
  Production = 'production',
}

export const IS_ONE_TOOL = Boolean(import.meta.env.VITE_APP_IS_ONE_TOOL === 'true');
export const ONE_TOOL_NAME = import.meta.env.VITE_APP_ONE_TOOL_NAME;
export const AIBaseUrl = import.meta.env.VITE_APP_AI_API_URL;

export enum ValidationReasons {
  FAILURE_SPACE_LIMIT_REACHED = 'failure_space_limit_reached',
  SPACE_QUOTA_EXCEEDED = 'space_quota_exceeded',
}

export enum REMOTE_SETTINGS_TYPES {
  batch_editor_miniapp = 'batch_editor_miniapp',
}

export enum GLOBAL_DATA {
  placeholder = 'Example: restaurant table at Parisian outdoor cafe',
}

export enum AIBGGenerateType {
  GENERATE = 'generate',
  SELECT = 'select',
}

export const INITIAL_EXPORT_INFO = {
  count: 0,
  exportType: null,
};

export enum BOX_SIZES {
  HEIGHT = 330,
  WIDTH = 330,
}
